import { isIP, isURL } from "validator";
import { JUSTIFICATION_MAX_LENGTH } from "../constants/constants";
export { isPersonalNameValid as isNameValid } from "uicomponents";

export function isEmailValid(email: string): boolean {
  const regExp = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
  return regExp.test(email);
}

export function isUserIdValid(userId: string): boolean {
  return isSignInName(userId) || isEmailValid(userId) || isPhoneNumber(userId);
}

export function isJustificationValid(justification: string): boolean {
  return justification.length >= 1 && justification.length <= JUSTIFICATION_MAX_LENGTH;
}

export function isValidUrl(url: string): boolean {
  return isURL(url, {
    protocols: ['http', 'https'],
    require_protocol: true,
    require_valid_protocol: true
  }) && !isIP(new URL(url).hostname);
}

export function isAlphaNumeric(inputString: string): boolean {
  const regExp = new RegExp(/^([a-zA-Z0-9 _-]+)$/);
  return regExp.test(inputString);
}

export function isAlphabetic(inputString: string): boolean {
  const regExp = new RegExp(/^([a-zA-Z _-]+)$/);
  return regExp.test(inputString);
}

export function isNumeric(inputString: string): boolean {
  const regExp = new RegExp(/^[0-9\b]+$/);
  return regExp.test(inputString);
}

export function isSignInName(inputString: string): boolean {
  const regExp = new RegExp(/^[a-zA-Z][a-zA-Z0-9._-]{2,100}$/);
  return regExp.test(inputString);
}

export function isPhoneNumber(inputString: string): boolean {
  const regExp = new RegExp(/^[1-9]\d{1,14}$/);
  return regExp.test(inputString);
}